module.exports = __webpack_public_path__ + "static/1_3_chinese-room-2e4e0257d167c1d9c302d4f537d21127.svg";